import { useState } from 'react';
import { closest, distance } from 'fastest-levenshtein';
import { useTracking } from '@podiumhq/tracking';

import { validateEmail } from 'lib/fieldValidation';

import { EMAIL_DOMAINS } from '../constants';

const useSuggestEmail = () => {
  const { trackEvent } = useTracking();
  const [suggestedEmail, setSuggestedEmail] = useState('');

  const handleEmailSuggestion = (email, setEmail) => {
    setEmail && setEmail(suggestedEmail);
    setSuggestedEmail('');
    trackEvent('trials.suggestedEmail.clicked', { email, suggestedEmail });
  };

  const spellCheckEmail = (email) => {
    const isValidEmail = validateEmail(email);

    if (isValidEmail) {
      const [emailName, emailDomain] = email.split('@');
      const suggestedDomain = closest(emailDomain, EMAIL_DOMAINS);
      const dist = distance(emailDomain, suggestedDomain);

      if (dist > 1 && dist < 4) {
        const suggestedEmail = emailName + '@' + suggestedDomain;
        trackEvent('trials.suggestedEmail.suggested', {
          email,
          suggestedEmail,
        });
        setSuggestedEmail(suggestedEmail);
      } else if (emailDomain.includes('.con')) {
        const [sld] = emailDomain.split('.');
        setSuggestedEmail(emailName + '@' + sld + '.com');
      } else {
        setSuggestedEmail('');
      }
    }
  };

  return { handleEmailSuggestion, spellCheckEmail, suggestedEmail };
};

export default useSuggestEmail;
